(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("gMyUj", function(module, exports) {
const $c37c34e6a36d0594$var$leafletsGroups = document.querySelectorAll(".s-leaflets__group");
$c37c34e6a36d0594$var$leafletsGroups.forEach((group)=>{
    group.addEventListener("initLeafletsGroup", ()=>{
        console.log("initLeafletsGroup");
        const leaflets = group.querySelectorAll(".i-leaflet");
        console.log(leaflets);
        if (group.classList.contains("--active")) leaflets.forEach((leaflet)=>{
            leaflet.dispatchEvent(new Event("initLeaflet"));
        });
    });
});

});

})();
//# sourceMappingURL=leaflets-section.1e3af17e.js.map
